import { ApiHelper, PresignedUpload } from ".";
import Axios, { AxiosProgressEvent } from "axios";

export class FileHelper {

  static startVideoEncode = async (key: string, vertical: boolean, audio: boolean): Promise<string> => {
    const params = { key, vertical, audio };
    const data = await ApiHelper.post<{ awsJobId: string }>("/files/startVideoEncode", params);
    return data.awsJobId;
  };


  static preUpload = async (contentType: string, contentId: number, questionId: number, file: File, fileName: string, progressCallback: (percent: number) => void, currentIndex?: number, totalFiles?: number): Promise<string> => {
    const cleanFileName = fileName.replace(/[^\w\\.]/gi, '')
    const params = { contentType, contentId, questionId, fileName: cleanFileName };
    const presigned = await ApiHelper.post<PresignedUpload>("/files/authorizeUpload", params);
    const doUpload = presigned.key !== undefined;
    if (doUpload) await FileHelper.postPresignedFile(presigned, file, progressCallback, currentIndex || 1, totalFiles || 1);
    return presigned.key;
  };

  private static postPresignedFile = (presigned: PresignedUpload, file: File, progressCallback: (percent: number) => void, currentIndex: number, totalFiles: number) => {
    const formData = new FormData();
    //formData.append("key", presigned.key);
    formData.append("acl", "public-read");
    formData.append("Content-Type", file.type);
    for (const property in presigned.fields) formData.append(property, presigned.fields[property]);
    formData.append("file", file);

    const axiosConfig = {
      headers: { "Content-Type": "multipart/form-data", },
      onUploadProgress: (data: AxiosProgressEvent) => {
        const filePercent = Math.round((100 * data.loaded) / (data.total || 1));
        if (totalFiles > 1) {
          const otherFilesPercent = ((currentIndex - 1) / totalFiles) * 100;
          const result = Math.round(otherFilesPercent + (filePercent / totalFiles));
          progressCallback(result);
        } else progressCallback(filePercent)
      },
    };

    return Axios.post(presigned.url, formData, axiosConfig);
  };

  static createJson = (jsonString: string) => {
    const fileName = new Date().getTime().toString() + ".json";
    return new File([jsonString], fileName, { type: "application/json" });
  }

  static dataURLtoFile = (dataurl: string, filename: string) => {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  static stringToFile = (contents: string, dataType: string, fileName: string) => {
    var blob = new Blob([contents], { type: dataType });
    return new File([blob], fileName, { type: dataType });
  }

}